"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var GrammarDescriptionStore = /*#__PURE__*/function (_RootStore) {
  function GrammarDescriptionStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, GrammarDescriptionStore);
    _this = _callSuper(this, GrammarDescriptionStore);
    _this.config = {
      model: _models.GrammarDescription,
      deserialize: true,
      GET: {
        index: '/grammar_descriptions',
        show: '/grammar_descriptions/:grammarDescriptionId'
      },
      POST: {
        create: '/grammar_descriptions',
        report: '/grammar_description_reports',
        evaluate: '/grammar_descriptions/:grammarDescriptionId/evaluate'
      },
      PUT: {
        update: '/grammar_descriptions/:grammarDescriptionId',
        cleanup: '/grammar_descriptions/:grammarDescriptionId/cleanup',
        proposeTranslation: '/grammar_descriptions/:grammarDescriptionId/propose_translation',
        translate: '/grammar_descriptions/:grammarDescriptionId/translate',
        cancelRetranslations: '/grammar_descriptions/:grammarDescriptionId/cancel_retranslations'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(GrammarDescriptionStore, _RootStore);
  return (0, _createClass2["default"])(GrammarDescriptionStore, [{
    key: "report",
    value: function report(params, callback) {
      this.api(params, callback, 'POST', 'report');
    }
  }, {
    key: "evaluate",
    value: function evaluate(params, callback) {
      this.api(params, callback, 'POST', 'evaluate');
    }
  }, {
    key: "proposeTranslation",
    value: function proposeTranslation(params, callback) {
      this.api(params, callback, 'PUT', 'proposeTranslation');
    }
  }, {
    key: "cleanup",
    value: function cleanup(params, callback) {
      this.api(params, callback, 'PUT', 'cleanup');
    }
  }, {
    key: "translate",
    value: function translate(params, callback) {
      this.api(params, callback, 'PUT', 'translate');
    }
  }, {
    key: "cancelRetranslations",
    value: function cancelRetranslations(params, callback) {
      this.api(params, callback, 'PUT', 'cancelRetranslations');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new GrammarDescriptionStore();